module.exports = __webpack_public_path__ + "static/tt-desktop-stock-screen-0a0b250ff8a12c8935669999b98f1a69.png";